import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetOrganizationWithID = async (
  organizationId,
  token = null
) => {
  const TOKEN = token || sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') + '/getOrganizationCorpEntities'

  return await axios({
    url: URL,
    method: 'GET',
    params: {
      organizationId: organizationId
    },
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
